/*
    SUMMARY
    0 - FUNCTIONS
    1 - REMOVE (FOOTER / HEADER / ZOOM)
    2 - FORMS

*/

/*----------------------/ 0 - FUNCTIONS /----------------------*/
const regex = /[0-9]/;

function showMessageError(id) {
    const element = document.getElementById(id)
    element.classList.add("error--message")
}

function removeAllError() {
    const inputGroup = document.querySelectorAll(".container--input")
    inputGroup.forEach(group => {
        group.classList.remove("error--message")
    })
}


/*----------------------/ 1 - REMOVE (FOOTER / HEADER) /----------------------*/
$(document).ready(function () {
    const footer = document.querySelector('footer')
    footer.style.display = 'none'

    const imgDetails = document.querySelector('.image--details-footer')
    imgDetails.style.display = 'none'

    const header = document.querySelector('header')
    header.style.display = 'none'

    const body = document.body
    body.classList.add("remove--zoom")
})

/*----------------------/ 2 - FORMS /----------------------*/
$("#login-exams").on('submit', function (e) {
    removeAllError()
    console.log('call')
    e.preventDefault();
    var email = $("#lg-user").val();
    var password = $("#lg-password").val();

    function isValidEmail(emailAddress) {
        var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
        return pattern.test(emailAddress);
    };

    let error = false;

    if (isValidEmail(email) == false && !error) {
        error = true;
        showMessageError('ms-user')

    }

    if (!password && !error) {
        error = true;
        showMessageError('ms-password')
    }

    var url = $(this).attr('action');

    if (!error) {
        grecaptcha.ready(function () {
            grecaptcha.execute($("#recaptcha").val(), {
                action: 'submit'
            }).then(function (token) {
                var dataString = 'name=' + name + '&email=' + email + '&phone=' + phone + '&subject=' + subject + '&message=' + message + '&gRecaptchaResponse=' + token;
                $.ajax({
                    type: "POST",
                    url: url,
                    headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: dataString,
                    dataType: 'json',
                    success: function (json) {
                        if (json.status == true) {
                            $('.success-message').html("<div><i class='fa-solid fa-circle-check'></i> <span>Seu cadastro foi realizado<br><b>com sucesso!</b></span></div>");
                            $("#ct-email").val('');
                            $("#ct-name").val('');
                            $("#ct-phone").val('');
                            $("#ct-subject").val('');
                            $("#ct-message").val('');
                            $('.success-message').fadeIn(3000, () => {
                                $('.success-message').fadeOut(3000);
                            });
                            $('.fail-message').fadeOut(3000);
                        } else {
                            $('.fail-message').html(`<div class='danger-box'><i class='fa-solid fa-circle-xmark'></i> ${json.txt} </div>`);
                            $('.fail-message').fadeIn(3000, () => {
                                $('.fail-message').fadeOut(3000);
                            });
                            $('.success-message').fadeOut(3000);
                        }
                    }
                });
            });
        });
    }
    else {
        $('.fail-message').fadeIn(3000, () => {
            $('.fail-message').fadeOut(3000);
        });
        $('.success-message').fadeOut(3000);
    }
    return false;
});